import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import { DataColumn } from "../controls/Data.default";
import {
  buildSearchQuery,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";

export interface LoginLogsForm {
  readonly userUserName?: string;
  readonly companyName?: string;
  readonly ipAddress?: string;
  readonly loginProvider?: string;
}

export const loginLogsViewColumns: DataColumn[] = [
  {
    title: "Timestamp",
    key: "timestamp",
    width: 168,
    sort: true,
    defaultSort: "desc",
    format: "DD/MM/YYYY HH:mm:ss",
    fixed: "left",
  },
  { title: "User", key: "userUserName", width: 220, sort: true },
  { title: "Company", key: "companyName", width: 220, sort: true },
  { title: "Department", key: "departmentName", width: 180, sort: true },
  { title: "Login Provider", key: "loginProvider", width: 140, sort: true },
  { title: "IP Address", key: "ipAddress", width: 140, sort: true },
  { title: "Device", key: "deviceInfo", width: 320, sort: true },
];

const loginLogsQueryMappings: QueryFieldMapping[] = [
  { formField: "userUserName", operation: QueryOperation.StartsWith },
  { formField: "companyName", operation: QueryOperation.StartsWith },
  { formField: "ipAddress", operation: QueryOperation.StartsWith },
  { formField: "loginProvider", operation: QueryOperation.StartsWith },
];

export const mapLoginLogsViewQuery = (values: LoginLogsForm): SearchQuery =>
  buildSearchQuery(values, loginLogsQueryMappings);
